<div class="flex flex-col px-6 pt-6 items-center gap-2">
  <div class="flex items-center w-full">
    <div class="grow"></div>
    <button
      mat-icon-button
      (click)="onClose()"
      class="w-auto"
      [attr.aria-label]="'Close' | translate">
      <mat-icon svgIcon="close-affordance" class="icon-size [--icon-size:48px] !text-on-surface-variant"></mat-icon>
    </button>
  </div>
  <h1 class="headline-small text-primary flex-1 text-center">{{ 'Regenerate all documents' | translate }}</h1>
</div>

<app-dialog-content>
  <div class="flex flex-col gap-6">
    <p class="body-medium text-on-surface-variant m-0">
      {{
        'The patient or visit linked to this consultation has changed, regenerating will create new versions of the documents using the updated patient and visit information.'
          | translate
      }}
    </p>
    <div class="flex items-center gap-2 w-full px-3 py-2 rounded-[4px] bg-tertiary-99 border border-tertiary-50">
      <mat-icon svgIcon="warning-triangle" class="!text-tertiary-30 shrink-0"></mat-icon>
      <p class="label-large !text-tertiary-30 m-0">
        {{
          'If you skip regeneration, existing documents will not be updated and may contain information that does not match the newly selected patient or visit.'
            | translate
        }}
      </p>
    </div>
  </div>
</app-dialog-content>

<app-dialog-footer>
  <div class="flex flex-col-reverse md:flex-row items-center gap-2 md:gap-3 pt-6 w-full">
    <button
      mat-stroked-button
      color="primary"
      (click)="onClose()"
      class="max-md:w-full shrink-0">
      {{ 'Cancel' | translate }}
    </button>
    <button
      mat-stroked-button
      color="primary"
      (click)="onSkip()"
      class="w-full">
      {{ 'Skip regeneration' | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      (click)="onRegenerate()"
      class="w-full">
      <mat-icon svgIcon="refresh"></mat-icon>
      {{ 'Regenerate all' | translate }}
    </button>
  </div>
</app-dialog-footer>
